<template>
  <div
    ref="draggableContainer"
    class="draggable-container"
    :style="containerStyle"
  >
    <div
      class="draggable-content"
      @mousedown="handleMouseDown"
    >
      <slot>
        <div class="draggable-container__default">
          Default draggable object.
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      currentX: 0,
      currentY: 0,
      initialX: 0,
      initialY: 0,
      xOffset: 0,
      yOffset: 0,
    };
  },
  computed: {
    containerStyle() {
      return {
        transform: `translate3d(${this.xOffset}px, ${this.yOffset}px, 0)`,
        cursor: this.isDragging ? 'grabbing' : 'grab',
      };
    },
  },
  mounted() {
    const savedPosition = localStorage.getItem('calculatorPosition');
    if (savedPosition) {
      try {
        const { x, y } = JSON.parse(savedPosition);
        this.$nextTick(() => {
          const { minX, minY, maxX, maxY } = this.getBoundaryConstraints();
          this.xOffset = Math.min(Math.max(x || 0, minX), maxX);
          this.yOffset = Math.min(Math.max(y || 0, minY), maxY);
        });
      } catch (e) {
        console.error('Failed to parse calculatorPosition from localStorage:', e);
        localStorage.removeItem('calculatorPosition');
      }
    }
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
  methods: {
    getBoundaryConstraints() {
      const container = this.$refs.draggableContainer;
      const containerRect = container ? container.getBoundingClientRect() : { width: 300, height: 400 };
      const containerWidth = containerRect.width || 300;
      const containerHeight = containerRect.height || 400;
      const visiblePixels = 60;
      return {
        minX: -(containerWidth - visiblePixels),
        minY: -(containerHeight - visiblePixels),
        maxX: window.innerWidth - visiblePixels,
        maxY: window.innerHeight - visiblePixels,
      };
    },
    handleMouseDown(event) {
      if (event.target.tagName === 'BUTTON' || event.target.closest('button')) {
        return;
      }
      this.dragStart(event);
    },
    dragStart(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragging = true;
      this.initialX = event.clientX - this.xOffset;
      this.initialY = event.clientY - this.yOffset;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.dragEnd);
      document.body.style.userSelect = 'none';
    },
    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.removeEventListeners();
      localStorage.setItem('calculatorPosition', JSON.stringify({
        x: this.xOffset,
        y: this.yOffset,
      }));
    },
    drag(event) {
      if (this.isDragging) {
        event.preventDefault();
        this.currentX = event.clientX - this.initialX;
        this.currentY = event.clientY - this.initialY;
        const { minX, minY, maxX, maxY } = this.getBoundaryConstraints();
        this.xOffset = Math.min(Math.max(this.currentX, minX), maxX);
        this.yOffset = Math.min(Math.max(this.currentY, minY), maxY);
      }
    },
    removeEventListeners() {
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.dragEnd);
      document.body.style.userSelect = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  user-select: none;

  .draggable-content {
    position: relative;
    cursor: grab;
    &:active {
      cursor: grabbing;
    }
  }

  .draggable-container__default {
    padding: 1rem;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
  }
}

</style>
